import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            backgroundColor: '#1D474F',
            padding: '8px 24px 16px',
        },
        arcodionRoot: {
            borderBottom: '1px solid #CCDADB',
            backgroundColor: 'transparent',
        },
        sumaryRoot: {
            minHeight: '60px !important',
            backgroundColor: '#1D474F !important',
            padding: 0,
        },
        heading: {
            fontSize: 16,
            fontWeight: 600,
            color: 'white',
            fontFamily: 'PoppinsRegular',
        },
        contentAccordion: {
            fontSize: 14,
            fontWeight: 400,
            color: 'white',
            fontFamily: 'PoppinsRegular',
        },
        content: {
            margin: '0 !important',
        },
        expanded: {
            margin: '0 !important',
        },
    }),
);

export default function FAQ() {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState<string | false>(false);

    const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <div className={classes.root}>
            <Accordion
                expanded={expanded === 'panel1'}
                onChange={handleChange('panel1')}
                classes={{
                    root: classes.arcodionRoot,
                    expanded: classes.expanded,
                }}
                style={{
                    boxShadow: 'none',
                }}
            >
                <AccordionSummary
                    classes={{
                        root: classes.sumaryRoot,
                        content: classes.content,
                    }}
                    expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography className={classes.heading}>General settings</Typography>
                </AccordionSummary>
                <AccordionDetails
                    classes={{
                        root: classes.root,
                    }}
                >
                    <Typography className={classes.contentAccordion}>
                        Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat. Aliquam eget maximus est,
                        id dignissim quam.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion
                expanded={expanded === 'panel2'}
                onChange={handleChange('panel2')}
                classes={{
                    root: classes.arcodionRoot,
                    expanded: classes.expanded,
                }}
                style={{
                    boxShadow: 'none',
                }}
            >
                <AccordionSummary
                    classes={{
                        root: classes.sumaryRoot,
                        content: classes.content,
                    }}
                    expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                >
                    <Typography className={classes.heading}>Users</Typography>
                </AccordionSummary>
                <AccordionDetails
                    classes={{
                        root: classes.root,
                    }}
                >
                    <Typography className={classes.contentAccordion}>
                        Donec placerat, lectus sed mattis semper, neque lectus feugiat lectus, varius pulvinar diam eros
                        in elit. Pellentesque convallis laoreet laoreet.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion
                expanded={expanded === 'panel3'}
                onChange={handleChange('panel3')}
                classes={{
                    root: classes.arcodionRoot,
                    expanded: classes.expanded,
                }}
                style={{
                    boxShadow: 'none',
                }}
            >
                <AccordionSummary
                    classes={{
                        root: classes.sumaryRoot,
                        content: classes.content,
                    }}
                    expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                >
                    <Typography className={classes.heading}>Advanced settings</Typography>
                </AccordionSummary>
                <AccordionDetails
                    classes={{
                        root: classes.root,
                    }}
                >
                    <Typography className={classes.contentAccordion}>
                        Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit amet egestas eros, vitae
                        egestas augue. Duis vel est augue.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion
                expanded={expanded === 'panel4'}
                onChange={handleChange('panel4')}
                classes={{
                    root: classes.arcodionRoot,
                    expanded: classes.expanded,
                }}
                style={{
                    boxShadow: 'none',
                }}
            >
                <AccordionSummary
                    classes={{
                        root: classes.sumaryRoot,
                        content: classes.content,
                    }}
                    expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className={classes.heading}>Personal data</Typography>
                </AccordionSummary>
                <AccordionDetails
                    classes={{
                        root: classes.root,
                    }}
                >
                    <Typography className={classes.contentAccordion}>
                        Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit amet egestas eros, vitae
                        egestas augue. Duis vel est augue.
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}
